// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../../utils/Utils.bs.js");
let RelayEnv = require("../../../RelayEnv.bs.js");
let DebounceP = require("../../../reason/common/DebounceP.bs.js");
let ReasonPromise = require("../../../reason/ReasonPromise.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let AutocompleteV5 = require("../../autocomplete/AutocompleteV5.bs.js");
let Utils__Promise = require("../../../utils/Utils__Promise.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let SelectInputTextSize = require("../../common/Form/SelectInputTextSize.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertiesFiltersAreasAutocompleteQuery_graphql = require("../../../__generated__/PropertiesFiltersAreasAutocompleteQuery_graphql.bs.js");
let PropertiesFiltersAreasAutocomplete_propertiesFilters_areas_graphql = require("../../../__generated__/PropertiesFiltersAreasAutocomplete_propertiesFilters_areas_graphql.bs.js");
let PropertiesFiltersAreasAutocomplete_propertiesFilters_schools_graphql = require("../../../__generated__/PropertiesFiltersAreasAutocomplete_propertiesFilters_schools_graphql.bs.js");
let PropertiesFiltersAreasAutocomplete_propertiesFilters_schoolDistricts_graphql = require("../../../__generated__/PropertiesFiltersAreasAutocomplete_propertiesFilters_schoolDistricts_graphql.bs.js");

let getConnectionNodes = PropertiesFiltersAreasAutocomplete_propertiesFilters_areas_graphql.Utils.getConnectionNodes;

let convertFragment = PropertiesFiltersAreasAutocomplete_propertiesFilters_areas_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertiesFiltersAreasAutocomplete_propertiesFilters_areas_graphql.node, convertFragment, fRef);
}

function readInline(fRef) {
  return RescriptRelay_Fragment.readInlineData(PropertiesFiltersAreasAutocomplete_propertiesFilters_areas_graphql.node, convertFragment, fRef);
}

let AreasFragment = {
  getConnectionNodes: getConnectionNodes,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  readInline: readInline
};

let getConnectionNodes$1 = PropertiesFiltersAreasAutocomplete_propertiesFilters_schools_graphql.Utils.getConnectionNodes;

let convertFragment$1 = PropertiesFiltersAreasAutocomplete_propertiesFilters_schools_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertiesFiltersAreasAutocomplete_propertiesFilters_schools_graphql.node, convertFragment$1, fRef);
}

function readInline$1(fRef) {
  return RescriptRelay_Fragment.readInlineData(PropertiesFiltersAreasAutocomplete_propertiesFilters_schools_graphql.node, convertFragment$1, fRef);
}

let SchoolsFragment = {
  getConnectionNodes: getConnectionNodes$1,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  readInline: readInline$1
};

let getConnectionNodes$2 = PropertiesFiltersAreasAutocomplete_propertiesFilters_schoolDistricts_graphql.Utils.getConnectionNodes;

let convertFragment$2 = PropertiesFiltersAreasAutocomplete_propertiesFilters_schoolDistricts_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertiesFiltersAreasAutocomplete_propertiesFilters_schoolDistricts_graphql.node, convertFragment$2, fRef);
}

function readInline$2(fRef) {
  return RescriptRelay_Fragment.readInlineData(PropertiesFiltersAreasAutocomplete_propertiesFilters_schoolDistricts_graphql.node, convertFragment$2, fRef);
}

let SchoolsDistrictsFragment = {
  getConnectionNodes: getConnectionNodes$2,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  readInline: readInline$2
};

let convertVariables = PropertiesFiltersAreasAutocompleteQuery_graphql.Internal.convertVariables;

let convertResponse = PropertiesFiltersAreasAutocompleteQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = PropertiesFiltersAreasAutocompleteQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, PropertiesFiltersAreasAutocompleteQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, PropertiesFiltersAreasAutocompleteQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(PropertiesFiltersAreasAutocompleteQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch(PropertiesFiltersAreasAutocompleteQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(PropertiesFiltersAreasAutocompleteQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(PropertiesFiltersAreasAutocompleteQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function queryFn(searchTerm) {
  return fetchPromised(RelayEnv.environment, {
    searchTerm: searchTerm
  }, undefined, undefined);
}

function getOptionValue(param) {
  return param.id;
}

function getOptionLabel(param) {
  return param.label;
}

let Area = {
  getOptionValue: getOptionValue,
  getOptionLabel: getOptionLabel
};

function queryFn$1(input) {
  return ReasonPromise.mapOk(ReasonPromise.map(Utils__Promise.fromJsPromise(queryFn(input)), v => {
    if (v.TAG !== "Ok") {
      return {
        TAG: "Error",
        _0: {
          NAME: "REJECTED",
          VAL: v._0
        }
      };
    }
    let result = v._0.propertySearchAreasAutocomplete;
    if (result !== undefined) {
      return {
        TAG: "Ok",
        _0: result
      };
    } else {
      return {
        TAG: "Error",
        _0: "EMPTY_RESPONSE"
      };
    }
  }), response => {
    let match = RescriptRelay_Fragment.readInlineData(PropertiesFiltersAreasAutocomplete_propertiesFilters_areas_graphql.node, convertFragment, response.fragmentRefs);
    let areas = getConnectionNodes(match.areas).map(param => ({
      id: param.id,
      label: param.label
    }));
    let match$1 = RescriptRelay_Fragment.readInlineData(PropertiesFiltersAreasAutocomplete_propertiesFilters_schools_graphql.node, convertFragment$1, response.fragmentRefs);
    let schools = getConnectionNodes$1(match$1.schools).map(param => ({
      id: param.id,
      label: param.label
    }));
    let match$2 = RescriptRelay_Fragment.readInlineData(PropertiesFiltersAreasAutocomplete_propertiesFilters_schoolDistricts_graphql.node, convertFragment$2, response.fragmentRefs);
    let schoolDistricts = getConnectionNodes$2(match$2.schoolDistricts).map(param => ({
      id: param.id,
      label: param.label
    }));
    return [
      {
        label: "Areas",
        options: areas
      },
      {
        label: "Schools",
        options: schools
      },
      {
        label: "School districts",
        options: schoolDistricts
      }
    ];
  });
}

function PropertiesFiltersAreasAutocomplete(props) {
  let status = props.status;
  let queryFn$2 = DebounceP.make(300, input => Utils__Promise.toJsPromise(queryFn$1(input)));
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(AutocompleteV5.AsyncGroupSelect.Multi.make, {
      getOptionLabel: getOptionLabel,
      getOptionValue: getOptionValue,
      loadOptions: v => {
        let v$1 = Utils.$$String.trimInput(v);
        if (v$1.length < 2) {
          return Promise.resolve([]);
        } else {
          return queryFn$2(Utils.$$String.trimInput(v$1));
        }
      },
      isClearable: true,
      onBlur: props.onBlur,
      onFocus: props.onFocus,
      onChange: props.onChange,
      noOptionsMessage: v => v.length < 2 ? "Type at least two characters" : "No locations match \"" + v + "\"",
      placeholder: "City, Neighborhood, School, ZIP",
      status: status !== undefined ? (
          status === "ok" ? "Success" : "Failure"
        ) : "Neutral",
      value: Stdlib_Option.getOr(props.value, [])
    }),
    className: SelectInputTextSize.className
  });
}

let make = PropertiesFiltersAreasAutocomplete;

exports.AreasFragment = AreasFragment;
exports.SchoolsFragment = SchoolsFragment;
exports.SchoolsDistrictsFragment = SchoolsDistrictsFragment;
exports.Query = Query;
exports.Area = Area;
exports.queryFn = queryFn$1;
exports.make = make;
/* use Not a pure module */
